"use strict";

// ***********************************************************************
// Assembly         : Veriteq.Partner.Web
// Author           : Mike Palmer
// Created          : 06-21-2024
//
// Last Modified By : Mike Palmer
// Last Modified On : 06-21-2024
// ***********************************************************************
// <copyright file="_actions.js" company="NSA Group Ltd">
//     Copyright (c) NSA Group Ltd. All rights reserved.
// </copyright>
// <summary>
//     JavaScript utilities for launching phone applications and navigating to URLs.
// </summary>
// ***********************************************************************

window.actions = window.actions || {};

/**
 * Launches the device's phone application with the provided phone number.
 * This function constructs a `tel:` URL scheme and redirects the browser to it,
 * triggering the phone app on most mobile devices.
 *
 * @function launchPhoneApplication
 * @memberof window.actions
 * @param {string} phoneNumber - The phone number to dial. Must be a valid phone number string.
 */
window.actions.launchPhoneApplication = function (phoneNumber) {
  window.location.href = 'tel:' + phoneNumber;
};

/**
 * Navigates the current browser window to the specified URL.
 * This function changes the `window.location.href` to the given URL, effectively
 * redirecting the user to the new location.
 *
 * @function navigateToUrl
 * @memberof window.actions
 * @param {string} url - The destination URL to which the browser should navigate.
 */
window.actions.navigateToUrl = function (url) {
  window.location.href = url;
};

/**
 * Closes the current browser tab or window.
 * This function attempts to close the browser window using `window.close()`.
 * Note: Most modern browsers restrict this behavior unless the tab was opened
 * programmatically or the action is triggered by user interaction.
 *
 * @function closeBrowserTab
 * @memberof window.actions
 */
window.actions.closeBrowserTab = function () {
  window.close();
};
"use strict";

function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
window.clipboard = window.clipboard || {};
window.clipboard.copyText = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(value) {
    var area, copied, _t;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.p = _context.n) {
        case 0:
          _context.p = 0;
          _context.n = 1;
          return navigator.clipboard.writeText(value);
        case 1:
          return _context.a(2, true);
        case 2:
          _context.p = 2;
          _t = _context.v;
          area = document.createElement('textarea');
          area.value = value;
          area.style.position = 'fixed';
          area.style.opacity = '0';
          document.body.appendChild(area);
          area.focus();
          area.select();
          copied = false;
          try {
            copied = document.execCommand('copy');
          } catch (_unused2) {
            copied = false;
          }
          document.body.removeChild(area);
          return _context.a(2, copied);
      }
    }, _callee, null, [[0, 2]]);
  }));
  return function (_x) {
    return _ref.apply(this, arguments);
  };
}();
"use strict";

// ***********************************************************************
// Assembly         : Veriteq.Partner.Web
// Author           : Mike Palmer
// Created          : 06-01-2025
//
// Last Modified By : Mike Palmer
// Last Modified On : 06-01-2025
// ***********************************************************************
// <copyright file="tenant-style-loader.js" company="NSA Group Ltd">
//     Copyright (c) NSA Group Ltd. All rights reserved.
// </copyright>
// <summary>
//     JavaScript utility for dynamically loading a tenant-specific CSS
//     stylesheet into the document head based on the applicant's tenant.
// </summary>
// ***********************************************************************

window.tenant = window.tenant || {};

/**
 * Dynamically injects a CSS file into the document head based on the provided href.
 * If a tenant stylesheet has already been added, it updates its href instead of injecting a new one.
 *
 * @function loadCss
 * @memberof window.tenant
 * @param {string} href - The path to the CSS file to be loaded.
 */
window.tenant.loadCss = function (href) {
  var existing = document.getElementById('tenant-style');
  if (existing) {
    existing.href = href;
    return;
  }
  var link = document.createElement('link');
  link.id = 'tenant-style';
  link.rel = 'stylesheet';
  link.href = href;
  link.type = 'text/css';
  document.head.appendChild(link);
};

/**
 * Dynamically sets or updates the favicon for the application.
 * If a favicon link already exists, its href will be updated. Otherwise, a new link is injected.
 * A cache-busting query string is automatically added to force browsers to refresh the icon.
 *
 * @function setFavicon
 * @memberof window.tenant
 * @param {string} href - The path to the favicon file.
 */
window.tenant.setFavicon = function (href) {
  document.querySelectorAll("link[rel='icon'], link[rel='shortcut icon']").forEach(function (e) {
    return e.remove();
  });
  var link = document.createElement("link");
  link.rel = "shortcut icon";
  link.type = "image/png";
  link.href = href + "?v=" + Date.now();
  document.head.appendChild(link);
};
"use strict";

// ***********************************************************************
// Assembly         : Veriteq.Partner.Web
// Author           : Mike Palmer
// Created          : 06-21-2024
//
// Last Modified By : Mike Palmer
// Last Modified On : 06-21-2024
// ***********************************************************************
// <copyright file="_date-picker.js" company="NSA Group Ltd">
//     Copyright (c) NSA Group Ltd. All rights reserved.
// </copyright>
// <summary>
//     JavaScript utilities for initializing and handling date picker functionality
//     for input elements in a Blazor application.
// </summary>
// ***********************************************************************

window.picker = window.picker || {};

/**
 * Initializes the date picker for the specified element using Bootstrap's datepicker.
 * The date picker is configured with specific settings and linked to a .NET method
 * to handle date selection events.
 * 
 * @function initialize
 * @memberof window.picker
 * @param {object} dotNetHelper - The .NET object reference used to invoke methods in Blazor.
 * @param {string} elementId - The ID of the input element to initialize the date picker for.
 * @returns {function} A function that, when called, destroys the date picker instance.
 */
window.picker.initialize = function (dotNetHelper, elementId) {
  var element = document.getElementById(elementId);
  $(element).datepicker({
    format: "dd M yyyy",
    autoclose: true,
    orientation: 'auto'
  }).on('changeDate', handleDateChange);

  /**
   * Handles the date change event triggered by the date picker.
   * This function retrieves the selected date and invokes a Blazor method to handle it.
   * 
   * @function handleDateChange
   * @memberof window.picker
   * @private
   * @param {object} e - The jQuery event object representing the date change event.
   */
  var handleDateChange = function handleDateChange(e) {
    var date = $(element).datepicker('getDate');
    dotNetHelper.invokeMethodAsync('OnDateSelected', date);
  };

  /**
   * Aligns the position of the date picker dropdown relative to the input element.
   * Ensures that the date picker is properly positioned within the viewport,
   * adjusting for screen boundaries if necessary.
   * 
   * @function alignDatePicker
   * @memberof window.picker
   * @private
   */
  var alignDatePicker = function alignDatePicker() {
    var rect = element.getBoundingClientRect();
    var datePicker = document.querySelector('.datepicker-dropdown');
    if (datePicker) {
      datePicker.style.position = 'absolute';
      datePicker.style.top = "".concat(rect.bottom + window.scrollY, "px");
      datePicker.style.left = "".concat(rect.left + window.scrollX, "px");
      datePicker.style.width = 'auto';
      var datePickerRect = datePicker.getBoundingClientRect();
      var viewportWidth = window.innerWidth;
      var viewportHeight = window.innerHeight;
      if (datePickerRect.left < 0) {
        datePicker.style.left = '10px';
      }
      if (datePickerRect.right > viewportWidth) {
        datePicker.style.left = "".concat(rect.right - datePickerRect.width + window.scrollX, "px");
      }
      if (datePickerRect.bottom > viewportHeight) {
        datePicker.style.top = "".concat(rect.top - datePickerRect.height + window.scrollY, "px");
      }
    }
  };

  // Align the date picker when the input element gains focus
  element.addEventListener('focus', function () {
    setTimeout(alignDatePicker, 0);
  });

  // Return a function to destroy the date picker instance when no longer needed
  return function () {
    $(element).datepicker('destroy');
  };
};
"use strict";

// ***********************************************************************
// Assembly         : Veriteq.Partner.Web
// Author           : Mike Palmer
// Created          : 06-21-2024
//
// Last Modified By : Mike Palmer
// Last Modified On : 06-21-2024
// ***********************************************************************
// <copyright file="_dialog.js" company="NSA Group Ltd">
//     Copyright (c) NSA Group Ltd. All rights reserved.
// </copyright>
// <summary>
//     JavaScript utilities for showing and hiding Bootstrap modals, including 
//     management of modal stacking to handle multiple open modals.
// </summary>
// ***********************************************************************

window.dialog = window.dialog || {};
window.dialog.modalStack = 0;

/**
 * Displays a Bootstrap modal dialog with the specified ID.
 * This function initializes the modal with a static backdrop and disables keyboard interactions
 * to prevent accidental closing. It also manages the modal stack to correctly handle multiple modals.
 * 
 * @function showModal
 * @memberof window.dialog
 * @param {string} id - The ID of the modal element to display.
 */
window.dialog.showModal = function (id) {
  var backdropType = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'static';
  var modalElement = document.getElementById(id);
  var myModal = new window.bootstrap.Modal(modalElement, {
    backdrop: backdropType,
    keyboard: false
  });
  myModal.show();
  window.dialog.modalStack++;
  modalElement.addEventListener('hidden.bs.modal', function () {
    window.dialog.modalStack--;
    if (window.dialog.modalStack === 0) {
      var backdrop = document.querySelector('.modal-backdrop');
      if (backdrop) {
        backdrop.remove();
      }
    }
    modalElement.dataset.listenerAdded = true;
  });
};

/**
 * Displays a Bootstrap modal dialog with the specified ID.
 * This function initializes the modal with the option to disable the backdrop and enables
 * keyboard interactions, allowing the modal to be closed with the ESC key.
 * It also manages the modal stack to correctly handle multiple modals.
 *
 * @function showNavbarSearchModal
 * @memberof window.dialog
 * @param {string} id - The ID of the modal element to display.
 */
window.dialog.showNavbarSearchModal = function (id) {
  var modalElement = document.getElementById(id);
  var searchDialog = new window.bootstrap.Modal(modalElement, {
    backdrop: true,
    keyboard: true
  });
  document.removeEventListener('keydown', escKeyListener);
  document.removeEventListener('click', backdropClickListener);
  searchDialog.show();
  window.dialog.modalStack++;
  var escKeyListener = function escKeyListener(event) {
    if (event.key === 'Escape') {
      searchDialog.hide();
    }
  };
  var backdropClickListener = function backdropClickListener(event) {
    if (!modalElement.contains(event.target)) {
      searchDialog.hide();
    }
  };
  modalElement.addEventListener('hidden.bs.modal', function () {
    window.dialog.modalStack--;
    if (window.dialog.modalStack === 0) {
      var backdrop = document.querySelector('.modal-backdrop');
      if (backdrop) {
        backdrop.remove();
      }
    }
    document.addEventListener('keydown', escKeyListener);
    document.addEventListener('click', backdropClickListener);
  });
};

/**
 * Displays a Bootstrap modal dialog with the specified ID.
 * This function initializes the modal with a static backdrop and disables keyboard interactions
 * to prevent accidental closing. It also manages the modal stack to correctly handle multiple modals.
 *
 * @function showModal
 * @memberof window.dialog
 * @param {string} id - The ID of the modal element to display.
 */
window.dialog.showModalNoBackdrop = function (id) {
  var modalElement = document.getElementById(id);
  var myModal = new window.bootstrap.Modal(modalElement, {
    backdrop: false,
    keyboard: false
  });
  myModal.show();
};

/**
 * Hides a Bootstrap modal dialog with the specified ID.
 * This function hides the modal and ensures that it is properly removed from the view.
 * 
 * @function hideModal
 * @memberof window.dialog
 * @param {string} id - The ID of the modal element to hide.
 */
window.dialog.hideModal = function (id) {
  var modalElement = document.getElementById(id);
  var myModal = new window.bootstrap.Modal(modalElement);
  myModal.hide();
};
"use strict";

// ***********************************************************************
// Assembly         : Veriteq.Partner.Web
// Author           : Mike Palmer
// Created          : 06-28-2024
//
// Last Modified By : Mike Palmer
// Last Modified On : 06-28-2024
// ***********************************************************************
// <copyright file="dropdown.js" company="NSA Group Ltd">
//     Copyright (c) NSA Group Ltd. All rights reserved.
// </copyright>
// <summary>
//     JavaScript utility for handling clicks outside of a specified DOM element
//     to trigger a .NET method call in a Blazor application.
// </summary>
// ***********************************************************************

window.dropdown = window.dropdown || {};

/**
 * Attaches an event listener to detect clicks outside of a specified DOM element.
 * When a click outside the element is detected, the specified .NET method is invoked
 * asynchronously using Blazor's JS interop.
 *
 * @function handleClickOutside
 * @memberof window.dropdown
 * @param {object} dotNetHelper - The .NET object reference used to invoke .NET methods from JavaScript.
 * @param {string} elementId - The ID of the DOM element to monitor for outside clicks.
 * @returns {function} A function that removes the event listener when invoked.
 */
window.dropdown.handleClickOutside = function (dotNetHelper, elementId) {
  var element = document.getElementById(elementId);
  var handleClickOutside = function handleClickOutside(event) {
    if (element && !element.contains(event.target)) {
      dotNetHelper.invokeMethodAsync('OnClickOutsideAsync');
    }
  };
  if (element) {
    document.addEventListener('click', handleClickOutside);
  }
  return function () {
    return document.removeEventListener('click', handleClickOutside);
  };
};
"use strict";

// ***********************************************************************
// Assembly         : Veriteq.Partner.Web
// Author           : Mike Palmer
// Created          : 06-21-2024
//
// Last Modified By : Mike Palmer
// Last Modified On : 06-21-2024
// ***********************************************************************
// <copyright file="_file.js" company="NSA Group Ltd">
//     Copyright (c) NSA Group Ltd. All rights reserved.
// </copyright>
// <summary>
//     JavaScript utilities for handling file downloads from base64 encoded content.
// </summary>
// ***********************************************************************

window.file = window.file || {};

/**
 * Downloads a file from a base64 encoded string.
 *
 * @function download
 * @memberof window.file
 * @param {string} fileName - The name of the file to be downloaded.
 * @param {string} fileContentType - The MIME type of the file (e.g., 'application/pdf').
 * @param {string} byteBase64 - The base64 encoded string representing the file content.
 */
window.file.download = function (fileName, fileContentType, byteBase64) {
  var byteCharacters = atob(byteBase64);
  var byteNumbers = new Array(byteCharacters.length);
  for (var i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  var byteArray = new Uint8Array(byteNumbers);
  var blob = new Blob([byteArray], {
    type: fileContentType
  });
  var link = document.createElement('a');
  link.href = window.URL.createObjectURL(blob);
  link.download = fileName;
  link.click();
  window.URL.revokeObjectURL(link.href);
};
"use strict";

// ***********************************************************************
// Assembly         : Veriteq.Partner.Web
// Author           : Mike Palmer
// Created          : 06-21-2024
//
// Last Modified By : Mike Palmer
// Last Modified On : 06-21-2024
// ***********************************************************************
// <copyright file="_handler.js" company="NSA Group Ltd">
//     Copyright (c) NSA Group Ltd. All rights reserved.
// </copyright>
// <summary>
//     JavaScript utilities for handling browser events such as the beforeunload
//     event, enabling communication between JavaScript and Blazor components.
// </summary>
// ***********************************************************************

window.handler = window.handlers || {};

/**
 * Sets up a listener for the beforeunload event, ensuring that when the user
 * navigates away from the page, a .NET method is invoked to perform the necessary
 * cleanup, such as unlocking a record in the database.
 *
 * @function setupBeforeUnload
 * @memberof window.handlers
 * @param {object} dotNetObject - A reference to the Blazor .NET object, used to invoke methods in the .NET code.
 */
window.handler.setupBeforeUnload = function (dotNetObject) {
  window.addEventListener('beforeunload', function (_) {
    dotNetObject.invokeMethodAsync('UnlockRecord');
  });
};

/**
 * Checks whether the browser allows popups. This is used to ensure that
 * features requiring popup access (e.g., downloading PDFs or triggering external
 * auth flows) can function correctly.
 *
 * @function checkPopupAllowed
 * @memberof window.handler
 * @returns {boolean} True if popups are allowed, false if blocked.
 */
window.handler.checkPopupAllowed = function () {
  try {
    var popup = window.open("about:blank", "_blank", "width=100,height=100");
    if (!popup || popup.closed || typeof popup.closed === "undefined") {
      return false;
    }
    popup.close();
    return true;
  } catch (_unused) {
    return false;
  }
};

/**
 * Attempts to open a new browser window (popup) with the specified URL.
 * If the popup is blocked by the browser (e.g., due to user settings),
 * the user is notified with an alert.
 *
 * This method is commonly used for actions like downloading files,
 * printing documents, or starting external authentication flows
 * that require a new window context.
 *
 * @function tryOpenWindow
 * @memberof window.handler
 * @param {string} url - The URL to open in a new popup window.
 * @returns {boolean} Returns true if the popup was successfully opened, false if blocked.
 */
window.handler.tryOpenWindow = function (url) {
  var popup = window.open(url, "_blank");
  if (!popup || popup.closed || typeof popup.closed === "undefined") {
    alert("Popups are blocked! Please enable popups for this site to continue.");
    return false;
  }
  return true;
};

/**
 * Scrolls the specified DOM element into view smoothly. This is typically used
 * to bring a referenced section of a Blazor component into the visible area of the viewport.
 *
 * @function scrollToElementRef
 * @memberof window.handler
 * @param {HTMLElement} element - The DOM element to scroll into view.
 */
window.handler.scrollToElementRef = function (element) {
  if (element) {
    element.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
};

/**
 * Scrolls smoothly to a DOM element by its ID.
 *
 * @function scrollToElementId
 * @memberof window.handler
 * @param {string} elementId - The ID of the DOM element to scroll to.
 */
window.handler.scrollToElementId = function (elementId) {
  var el = document.getElementById(elementId);
  if (el) {
    el.scrollIntoView({
      behavior: 'smooth',
      block: 'start'
    });
  }
};

/**
 * Starts monitoring for user inactivity (idle time). When the user has not
 * interacted (mouse or keyboard) for the specified number of seconds, a .NET
 * method is invoked to allow the Blazor app to perform a session lock or logout.
 * Additionally, a warning can be triggered partway through the timeout window,
 * allowing the user to cancel the pending logout.
 *
 * * This function also registers a handler for browser/tab close (via `beforeunload`)
 *  * to invoke a .NET method and allow logout to be logged correctly.
 *
 * @function startIdleMonitorWithWarning
 * @memberof window.handler
 * @param {object} dotNetObject - A reference to the Blazor .NET object, used to invoke methods in .NET.
 * @param {number} totalTimeoutSeconds - The total idle timeout in seconds (e.g., 900 for 15 minutes).
 * @param {number} warningLeadTimeSeconds - The number of seconds before timeout to trigger a warning (e.g., 300 for 5-minute warning).
 */
window.handler.startIdleMonitorWithWarning = function (dotNetObject, totalTimeoutSeconds, warningLeadTimeSeconds) {
  var idleTime = 0;
  var warned = false;
  function resetIdleTime() {
    idleTime = 0;
    warned = false;
  }
  window.handler._resetIdleTime = resetIdleTime;
  clearInterval(window.handler._idleInterval);
  window.handler._idleInterval = setInterval(function () {
    idleTime++;
    if (idleTime >= totalTimeoutSeconds) {
      clearInterval(window.handler._idleInterval);
      dotNetObject.invokeMethodAsync('OnUserIdle');
    } else if (idleTime >= totalTimeoutSeconds - warningLeadTimeSeconds && !warned) {
      warned = true;
      dotNetObject.invokeMethodAsync('OnIdleWarning');
    }
  }, 1000);
  window.addEventListener('mousemove', resetIdleTime);
  window.addEventListener('keydown', resetIdleTime);
  window.addEventListener('beforeunload', function () {
    var sessionId = localStorage.getItem('session_id');
    if (sessionId) {
      navigator.sendBeacon("/api/user/browser-closed?sessionId=".concat(sessionId));
    }
  }, {
    passive: true
  });
};
window.handler.resetIdleMonitor = function () {
  if (window.handler._resetIdleTime) {
    window.handler._resetIdleTime();
  }
};

/**
 * Resets the idle timer manually, typically after the user responds to a warning dialog.
 *
 * @function resetIdleMonitor
 * @memberof window.handler
 */
window.handler.resetIdleMonitor = function () {
  window.handler._idleTime = 0;
};

/**
 * Stops the idle monitoring timer and removes event listeners.
 * Should be called during component disposal to clean up resources.
 *
 * @function stopIdleMonitor
 * @memberof window.handler
 */
window.handler.stopIdleMonitor = function () {
  clearInterval(window.handler._idleInterval);
  window.handler.resetIdleMonitor();
  window.removeEventListener('mousemove', function () {});
  window.removeEventListener('keydown', function () {});
  window.removeEventListener('beforeunload', window.handler._beforeUnloadHandler);
  window.handler._beforeUnloadHandler = null;
};

/**
 * Gets the current browser version.
 * @function stopIdleMonitor
 * @memberof window.handler
 */
window.handler.getBrowser = function () {
  var ua = navigator.userAgent;
  if (ua.includes("Firefox/")) return "Firefox";
  if (ua.includes("Edg/")) return "Edge";
  if (ua.includes("Chrome/") && !ua.includes("Edg/") && !ua.includes("OPR/") && !ua.includes("MiuiBrowser") && !ua.includes("MiBrowser")) return "Chrome";
  if (ua.includes("Safari/") && !ua.includes("Chrome/")) return "Safari";
  return "Unknown";
};
"use strict";

function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
// ***********************************************************************
// Assembly         : Veriteq.Partner.Web
// Author           : Mike Palmer
// Created          : 06-21-2024
//
// Last Modified By : Mike Palmer
// Last Modified On : 06-21-2024
// ***********************************************************************
// <copyright file="_input.js" company="NSA Group Ltd">
//     Copyright (c) NSA Group Ltd. All rights reserved.
// </copyright>
// <summary>
//     JavaScript utilities for preventing input on elements and adding border 
//     animation effects to enhance user interaction in a Blazor application.
// </summary>
// ***********************************************************************

window.input = window.input || {};

/**
 * Prevents user input on the specified input element by blocking keydown events.
 * This function disables typing into the input element by attaching an event listener
 * that prevents the default action for any key press.
 * 
 * @function preventInput
 * @memberof window.input
 * @param {string} elementId - The ID of the input element to disable.
 */
window.input.preventInput = function (elementId) {
  var input = document.getElementById(elementId);
  if (input) {
    input.addEventListener('keydown', function (event) {
      event.preventDefault();
    });
  }
};

/**
 * Restricts input to the specified allowed keys for the current event.
 * This function dynamically prevents default behavior for disallowed keypress events.
 *
 * @function restrictKeys
 * @memberof window.input
 * @param {string} elementId - The ID of the input element to restrict.
 * @param {string} allowedKeys - A string containing all allowed characters.
 */
window.input.restrictKeys = function (elementId, allowedKeys) {
  var input = document.getElementById(elementId);
  if (input) {
    var allowedSet = new Set((allowedKeys || '').toLowerCase().split(''));
    var navigationKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];
    input.addEventListener('keydown', function (event) {
      var rawKey = event.key || '';
      var key = rawKey.toLowerCase();
      if (!allowedSet.has(key) && !navigationKeys.includes(rawKey)) {
        event.preventDefault();
      }
    });
  }
};

/**
 * Restricts all MudCodeInput fields to A–Z (a-z), 0–9 and forces uppercase display and value.
 */
window.input.initMudCodeInputAlphaNumUppercase = function () {
  var allowedSet = new Set('abcdefghijklmnopqrstuvwxyz0123456789'.split(''));
  var navigationKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];
  var inputs = document.querySelectorAll('input.mud-input-slot[maxlength="1"]:not([disabled]):not([type="hidden"])');
  console.log("Found ".concat(inputs.length, " MudCodeInput fields"));
  inputs.forEach(function (input) {
    if (input.dataset.restrictAttached === 'true') return;
    input.dataset.restrictAttached = 'true';
    input.addEventListener('keydown', function (event) {
      var key = event.key.toLowerCase();
      if (!allowedSet.has(key) && !navigationKeys.includes(event.key)) {
        event.preventDefault();
      }
    });
    input.addEventListener('input', function () {
      window.input.recase(input, input.value.toUpperCase());
    });
  });
};

/**
 * Forces character casing on input to either upper or lower case.
 *
 * @function forceCase
 * @memberof window.input
 * @param {string} elementId - The ID of the input element.
 * @param {'upper' | 'lower'} casing - Desired casing format.
 */
window.input.forceCase = function (elementId, casing) {
  var input = document.getElementById(elementId);
  if (!input) return;
  input.addEventListener('input', function () {
    if (casing === 'upper') {
      window.input.recase(this, this.value.toUpperCase());
    } else if (casing === 'lower') {
      window.input.recase(this, this.value.toLowerCase());
    }
  });
};

/**
 * Replaces an input's value with a recased copy, keeping the caret where it was.
 * Leaves the input alone when nothing changes: writing the same value back moves the
 * caret in some inputs, and email inputs do not support selection at all.
 *
 * @function recase
 * @memberof window.input
 * @param {HTMLInputElement} input - The input to recase.
 * @param {string} cased - The value in the wanted casing.
 */
window.input.recase = function (input, cased) {
  if (cased === input.value) return;
  var start = input.selectionStart;
  var end = input.selectionEnd;
  input.value = cased;
  if (start !== null && end !== null) input.setSelectionRange(start, end);
};

/**
 * Applies case transformation and character restriction rules to input elements.
 *
 * This function scans the DOM for all `<input>` elements that have either
 * a `data-case` or `data-allowed` attribute. It applies a keydown filter
 * to restrict input to the specified characters and sets up an input handler
 * to enforce consistent casing (uppercase or lowercase) as the user types.
 *
 * Expected usage:
 * - `data-case="upper"` or `data-case="lower"`: transforms input casing.
 * - `data-allowed="abc123"`: restricts allowed characters during typing.
 *
 * This should be called after all relevant inputs are rendered in the DOM.
 * It can be called directly or triggered via `observeInputs()` for dynamic rendering.
 *
 * @function enforceInputRestrictions
 * @memberof window.input
 */
/**
 * Capitalises the first letter of every word, leaving deliberate inner capitals
 * alone so McDonald and Tanayaih-Louise survive, while MICHAEL becomes Michael.
 * Mirrors NameCaseConverter on the server.
 *
 * @function toNameCase
 * @memberof window.input
 * @param {string} value - The value to normalise.
 * @returns {string} The normalised value.
 */
window.input.toNameCase = function (value) {
  if (!value) return value;
  return value.trim().replace(/[A-Za-z]+/g, function (word) {
    var shouted = word.length > 1 && word === word.toUpperCase();
    return word.charAt(0).toUpperCase() + (shouted ? word.slice(1).toLowerCase() : word.slice(1));
  });
};

/**
 * Puts an organisation name or a title into title case exactly as ToTitleCase()
 * in Veriteq.Core does: acronyms in capitals, joining words in lower case after the
 * first word, and any word typed with a capital kept as typed unless the whole
 * value is in capitals. TitleCaseScriptTests holds the two to the same answers.
 *
 * @function toTitleCase
 * @memberof window.input
 * @param {string} value - The value to normalise.
 * @returns {string} The normalised value.
 */
window.input.titleAcronyms = ['NSA', 'UK', 'USA', 'EU', 'ROI', 'NHS', 'MOD', 'SIA', 'DBS', 'BPSS', 'BS', 'BA', 'PSA', 'HR', 'IT', 'PLC', 'LLP', 'LLC', 'CIC', 'UAE', 'AI', 'DVLA', 'HMRC', 'IVA', 'CCJ', 'GPG'];
window.input.titleSmallWords = ['a', 'an', 'and', 'at', 'by', 'for', 'from', 'in', 'of', 'on', 'or', 'the', 'to', 'upon', 'with'];
window.input.titleWord = function (word, first, shouting) {
  var letters = word.replace(/(?:[\0-\/:-@\[-`\{-\xA9\xAB-\xB1\xB4\xB6-\xB8\xBB\xBF\xD7\xF7\u02C2-\u02C5\u02D2-\u02DF\u02E5-\u02EB\u02ED\u02EF-\u036F\u0375\u0378\u0379\u037E\u0380-\u0385\u0387\u038B\u038D\u03A2\u03F6\u0482-\u0489\u0530\u0557\u0558\u055A-\u055F\u0589-\u05CF\u05EB-\u05EE\u05F3-\u061F\u064B-\u065F\u066A-\u066D\u0670\u06D4\u06D6-\u06E4\u06E7-\u06ED\u06FD\u06FE\u0700-\u070F\u0711\u0730-\u074C\u07A6-\u07B0\u07B2-\u07BF\u07EB-\u07F3\u07F6-\u07F9\u07FB-\u07FF\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u083F\u0859-\u085F\u086B-\u086F\u0888\u088F-\u089F\u08CA-\u0903\u093A-\u093C\u093E-\u094F\u0951-\u0957\u0962-\u0965\u0970\u0981-\u0984\u098D\u098E\u0991\u0992\u09A9\u09B1\u09B3-\u09B5\u09BA-\u09BC\u09BE-\u09CD\u09CF-\u09DB\u09DE\u09E2-\u09E5\u09F2\u09F3\u09FA\u09FB\u09FD-\u0A04\u0A0B-\u0A0E\u0A11\u0A12\u0A29\u0A31\u0A34\u0A37\u0A3A-\u0A58\u0A5D\u0A5F-\u0A65\u0A70\u0A71\u0A75-\u0A84\u0A8E\u0A92\u0AA9\u0AB1\u0AB4\u0ABA-\u0ABC\u0ABE-\u0ACF\u0AD1-\u0ADF\u0AE2-\u0AE5\u0AF0-\u0AF8\u0AFA-\u0B04\u0B0D\u0B0E\u0B11\u0B12\u0B29\u0B31\u0B34\u0B3A-\u0B3C\u0B3E-\u0B5B\u0B5E\u0B62-\u0B65\u0B70\u0B78-\u0B82\u0B84\u0B8B-\u0B8D\u0B91\u0B96-\u0B98\u0B9B\u0B9D\u0BA0-\u0BA2\u0BA5-\u0BA7\u0BAB-\u0BAD\u0BBA-\u0BCF\u0BD1-\u0BE5\u0BF3-\u0C04\u0C0D\u0C11\u0C29\u0C3A-\u0C3C\u0C3E-\u0C57\u0C5B\u0C5C\u0C5E\u0C5F\u0C62-\u0C65\u0C70-\u0C77\u0C7F\u0C81-\u0C84\u0C8D\u0C91\u0CA9\u0CB4\u0CBA-\u0CBC\u0CBE-\u0CDC\u0CDF\u0CE2-\u0CE5\u0CF0\u0CF3-\u0D03\u0D0D\u0D11\u0D3B\u0D3C\u0D3E-\u0D4D\u0D4F-\u0D53\u0D57\u0D62-\u0D65\u0D79\u0D80-\u0D84\u0D97-\u0D99\u0DB2\u0DBC\u0DBE\u0DBF\u0DC7-\u0DE5\u0DF0-\u0E00\u0E31\u0E34-\u0E3F\u0E47-\u0E4F\u0E5A-\u0E80\u0E83\u0E85\u0E8B\u0EA4\u0EA6\u0EB1\u0EB4-\u0EBC\u0EBE\u0EBF\u0EC5\u0EC7-\u0ECF\u0EDA\u0EDB\u0EE0-\u0EFF\u0F01-\u0F1F\u0F34-\u0F3F\u0F48\u0F6D-\u0F87\u0F8D-\u0FFF\u102B-\u103E\u104A-\u104F\u1056-\u1059\u105E-\u1060\u1062-\u1064\u1067-\u106D\u1071-\u1074\u1082-\u108D\u108F\u109A-\u109F\u10C6\u10C8-\u10CC\u10CE\u10CF\u10FB\u1249\u124E\u124F\u1257\u1259\u125E\u125F\u1289\u128E\u128F\u12B1\u12B6\u12B7\u12BF\u12C1\u12C6\u12C7\u12D7\u1311\u1316\u1317\u135B-\u1368\u137D-\u137F\u1390-\u139F\u13F6\u13F7\u13FE-\u1400\u166D\u166E\u1680\u169B-\u169F\u16EB-\u16ED\u16F9-\u16FF\u1712-\u171E\u1732-\u173F\u1752-\u175F\u176D\u1771-\u177F\u17B4-\u17D6\u17D8-\u17DB\u17DD-\u17DF\u17EA-\u17EF\u17FA-\u180F\u181A-\u181F\u1879-\u187F\u1885\u1886\u18A9\u18AB-\u18AF\u18F6-\u18FF\u191F-\u1945\u196E\u196F\u1975-\u197F\u19AC-\u19AF\u19CA-\u19CF\u19DB-\u19FF\u1A17-\u1A1F\u1A55-\u1A7F\u1A8A-\u1A8F\u1A9A-\u1AA6\u1AA8-\u1B04\u1B34-\u1B44\u1B4D-\u1B4F\u1B5A-\u1B82\u1BA1-\u1BAD\u1BE6-\u1BFF\u1C24-\u1C3F\u1C4A-\u1C4C\u1C7E\u1C7F\u1C8B-\u1C8F\u1CBB\u1CBC\u1CC0-\u1CE8\u1CED\u1CF4\u1CF7-\u1CF9\u1CFB-\u1CFF\u1DC0-\u1DFF\u1F16\u1F17\u1F1E\u1F1F\u1F46\u1F47\u1F4E\u1F4F\u1F58\u1F5A\u1F5C\u1F5E\u1F7E\u1F7F\u1FB5\u1FBD\u1FBF-\u1FC1\u1FC5\u1FCD-\u1FCF\u1FD4\u1FD5\u1FDC-\u1FDF\u1FED-\u1FF1\u1FF5\u1FFD-\u206F\u2072\u2073\u207A-\u207E\u208A-\u208F\u209D-\u2101\u2103-\u2106\u2108\u2109\u2114\u2116-\u2118\u211E-\u2123\u2125\u2127\u2129\u212E\u213A\u213B\u2140-\u2144\u214A-\u214D\u214F\u218A-\u245F\u249C-\u24E9\u2500-\u2775\u2794-\u2BFF\u2CE5-\u2CEA\u2CEF-\u2CF1\u2CF4-\u2CFC\u2CFE\u2CFF\u2D26\u2D28-\u2D2C\u2D2E\u2D2F\u2D68-\u2D6E\u2D70-\u2D7F\u2D97-\u2D9F\u2DA7\u2DAF\u2DB7\u2DBF\u2DC7\u2DCF\u2DD7\u2DDF-\u2E2E\u2E30-\u3004\u3008-\u3020\u302A-\u3030\u3036\u3037\u303D-\u3040\u3097-\u309C\u30A0\u30FB\u3100-\u3104\u3130\u318F-\u3191\u3196-\u319F\u31C0-\u31EF\u3200-\u321F\u322A-\u3247\u3250\u3260-\u327F\u328A-\u32B0\u32C0-\u33FF\u4DC0-\u4DFF\uA48D-\uA4CF\uA4FE\uA4FF\uA60D-\uA60F\uA62C-\uA63F\uA66F-\uA67E\uA69E\uA69F\uA6F0-\uA716\uA720\uA721\uA789\uA78A\uA7CE\uA7CF\uA7D2\uA7D4\uA7DD-\uA7F1\uA802\uA806\uA80B\uA823-\uA82F\uA836-\uA83F\uA874-\uA881\uA8B4-\uA8CF\uA8DA-\uA8F1\uA8F8-\uA8FA\uA8FC\uA8FF\uA926-\uA92F\uA947-\uA95F\uA97D-\uA983\uA9B3-\uA9CE\uA9DA-\uA9DF\uA9E5\uA9FF\uAA29-\uAA3F\uAA43\uAA4C-\uAA4F\uAA5A-\uAA5F\uAA77-\uAA79\uAA7B-\uAA7D\uAAB0\uAAB2-\uAAB4\uAAB7\uAAB8\uAABE\uAABF\uAAC1\uAAC3-\uAADA\uAADE\uAADF\uAAEB-\uAAF1\uAAF5-\uAB00\uAB07\uAB08\uAB0F\uAB10\uAB17-\uAB1F\uAB27\uAB2F\uAB5B\uAB6A-\uAB6F\uABE3-\uABEF\uABFA-\uABFF\uD7A4-\uD7AF\uD7C7-\uD7CA\uD7FC-\uD7FF\uE000-\uF8FF\uFA6E\uFA6F\uFADA-\uFAFF\uFB07-\uFB12\uFB18-\uFB1C\uFB1E\uFB29\uFB37\uFB3D\uFB3F\uFB42\uFB45\uFBB2-\uFBD2\uFD3E-\uFD4F\uFD90\uFD91\uFDC8-\uFDEF\uFDFC-\uFE6F\uFE75\uFEFD-\uFF0F\uFF1A-\uFF20\uFF3B-\uFF40\uFF5B-\uFF65\uFFBF-\uFFC1\uFFC8\uFFC9\uFFD0\uFFD1\uFFD8\uFFD9\uFFDD-\uFFFF]|\uD800[\uDC0C\uDC27\uDC3B\uDC3E\uDC4E\uDC4F\uDC5E-\uDC7F\uDCFB-\uDD06\uDD34-\uDD3F\uDD79-\uDD89\uDD8C-\uDE7F\uDE9D-\uDE9F\uDED1-\uDEE0\uDEFC-\uDEFF\uDF24-\uDF2C\uDF4B-\uDF4F\uDF76-\uDF7F\uDF9E\uDF9F\uDFC4-\uDFC7\uDFD0\uDFD6-\uDFFF]|\uD801[\uDC9E\uDC9F\uDCAA-\uDCAF\uDCD4-\uDCD7\uDCFC-\uDCFF\uDD28-\uDD2F\uDD64-\uDD6F\uDD7B\uDD8B\uDD93\uDD96\uDDA2\uDDB2\uDDBA\uDDBD-\uDDBF\uDDF4-\uDDFF\uDF37-\uDF3F\uDF56-\uDF5F\uDF68-\uDF7F\uDF86\uDFB1\uDFBB-\uDFFF]|\uD802[\uDC06\uDC07\uDC09\uDC36\uDC39-\uDC3B\uDC3D\uDC3E\uDC56\uDC57\uDC77\uDC78\uDC9F-\uDCA6\uDCB0-\uDCDF\uDCF3\uDCF6-\uDCFA\uDD1C-\uDD1F\uDD3A-\uDD7F\uDDB8-\uDDBB\uDDD0\uDDD1\uDE01-\uDE0F\uDE14\uDE18\uDE36-\uDE3F\uDE49-\uDE5F\uDE7F\uDEA0-\uDEBF\uDEC8\uDEE5-\uDEEA\uDEF0-\uDEFF\uDF36-\uDF3F\uDF56\uDF57\uDF73-\uDF77\uDF92-\uDFA8\uDFB0-\uDFFF]|\uD803[\uDC49-\uDC7F\uDCB3-\uDCBF\uDCF3-\uDCF9\uDD24-\uDD2F\uDD3A-\uDD3F\uDD66-\uDD6E\uDD86-\uDE5F\uDE7F\uDEAA-\uDEAF\uDEB2-\uDEC1\uDEC5-\uDEFF\uDF28-\uDF2F\uDF46-\uDF50\uDF55-\uDF6F\uDF82-\uDFAF\uDFCC-\uDFDF\uDFF7-\uDFFF]|\uD804[\uDC00-\uDC02\uDC38-\uDC51\uDC70\uDC73\uDC74\uDC76-\uDC82\uDCB0-\uDCCF\uDCE9-\uDCEF\uDCFA-\uDD02\uDD27-\uDD35\uDD40-\uDD43\uDD45\uDD46\uDD48-\uDD4F\uDD73-\uDD75\uDD77-\uDD82\uDDB3-\uDDC0\uDDC5-\uDDCF\uDDDB\uDDDD-\uDDE0\uDDF5-\uDDFF\uDE12\uDE2C-\uDE3E\uDE41-\uDE7F\uDE87\uDE89\uDE8E\uDE9E\uDEA9-\uDEAF\uDEDF-\uDEEF\uDEFA-\uDF04\uDF0D\uDF0E\uDF11\uDF12\uDF29\uDF31\uDF34\uDF3A-\uDF3C\uDF3E-\uDF4F\uDF51-\uDF5C\uDF62-\uDF7F\uDF8A\uDF8C\uDF8D\uDF8F\uDFB6\uDFB8-\uDFD0\uDFD2\uDFD4-\uDFFF]|\uD805[\uDC35-\uDC46\uDC4B-\uDC4F\uDC5A-\uDC5E\uDC62-\uDC7F\uDCB0-\uDCC3\uDCC6\uDCC8-\uDCCF\uDCDA-\uDD7F\uDDAF-\uDDD7\uDDDC-\uDDFF\uDE30-\uDE43\uDE45-\uDE4F\uDE5A-\uDE7F\uDEAB-\uDEB7\uDEB9-\uDEBF\uDECA-\uDECF\uDEE4-\uDEFF\uDF1B-\uDF2F\uDF3C-\uDF3F\uDF47-\uDFFF]|\uD806[\uDC2C-\uDC9F\uDCF3-\uDCFE\uDD07\uDD08\uDD0A\uDD0B\uDD14\uDD17\uDD30-\uDD3E\uDD40\uDD42-\uDD4F\uDD5A-\uDD9F\uDDA8\uDDA9\uDDD1-\uDDE0\uDDE2\uDDE4-\uDDFF\uDE01-\uDE0A\uDE33-\uDE39\uDE3B-\uDE4F\uDE51-\uDE5B\uDE8A-\uDE9C\uDE9E-\uDEAF\uDEF9-\uDFBF\uDFE1-\uDFEF\uDFFA-\uDFFF]|\uD807[\uDC09\uDC2F-\uDC3F\uDC41-\uDC4F\uDC6D-\uDC71\uDC90-\uDCFF\uDD07\uDD0A\uDD31-\uDD45\uDD47-\uDD4F\uDD5A-\uDD5F\uDD66\uDD69\uDD8A-\uDD97\uDD99-\uDD9F\uDDAA-\uDEDF\uDEF3-\uDF01\uDF03\uDF11\uDF34-\uDF4F\uDF5A-\uDFAF\uDFB1-\uDFBF\uDFD5-\uDFFF]|\uD808[\uDF9A-\uDFFF]|\uD809[\uDC6F-\uDC7F\uDD44-\uDFFF]|[\uD80A\uD812-\uD817\uD819\uD824-\uD82A\uD82D\uD82E\uD830-\uD832\uD836\uD83D\uD83F\uD87C\uD87D\uD87F\uD889-\uDBFF][\uDC00-\uDFFF]|\uD80B[\uDC00-\uDF8F\uDFF1-\uDFFF]|\uD80D[\uDC30-\uDC40\uDC47-\uDC5F]|\uD810[\uDFFB-\uDFFF]|\uD811[\uDE47-\uDFFF]|\uD818[\uDC00-\uDCFF\uDD1E-\uDD2F\uDD3A-\uDFFF]|\uD81A[\uDE39-\uDE3F\uDE5F\uDE6A-\uDE6F\uDEBF\uDECA-\uDECF\uDEEE-\uDEFF\uDF30-\uDF3F\uDF44-\uDF4F\uDF5A\uDF62\uDF78-\uDF7C\uDF90-\uDFFF]|\uD81B[\uDC00-\uDD3F\uDD6D-\uDD6F\uDD7A-\uDE3F\uDE97-\uDEFF\uDF4B-\uDF4F\uDF51-\uDF92\uDFA0-\uDFDF\uDFE2\uDFE4-\uDFFF]|\uD821[\uDFF8-\uDFFF]|\uD823[\uDCD6-\uDCFE\uDD09-\uDFFF]|\uD82B[\uDC00-\uDFEF\uDFF4\uDFFC\uDFFF]|\uD82C[\uDD23-\uDD31\uDD33-\uDD4F\uDD53\uDD54\uDD56-\uDD63\uDD68-\uDD6F\uDEFC-\uDFFF]|\uD82F[\uDC6B-\uDC6F\uDC7D-\uDC7F\uDC89-\uDC8F\uDC9A-\uDFFF]|\uD833[\uDC00-\uDCEF\uDCFA-\uDFFF]|\uD834[\uDC00-\uDEBF\uDED4-\uDEDF\uDEF4-\uDF5F\uDF79-\uDFFF]|\uD835[\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDEC1\uDEDB\uDEFB\uDF15\uDF35\uDF4F\uDF6F\uDF89\uDFA9\uDFC3\uDFCC\uDFCD]|\uD837[\uDC00-\uDEFF\uDF1F-\uDF24\uDF2B-\uDFFF]|\uD838[\uDC00-\uDC2F\uDC6E-\uDCFF\uDD2D-\uDD36\uDD3E\uDD3F\uDD4A-\uDD4D\uDD4F-\uDE8F\uDEAE-\uDEBF\uDEEC-\uDEEF\uDEFA-\uDFFF]|\uD839[\uDC00-\uDCCF\uDCEC-\uDCEF\uDCFA-\uDDCF\uDDEE\uDDEF\uDDFB-\uDFDF\uDFE7\uDFEC\uDFEF\uDFFF]|\uD83A[\uDCC5\uDCC6\uDCD0-\uDCFF\uDD44-\uDD4A\uDD4C-\uDD4F\uDD5A-\uDFFF]|\uD83B[\uDC00-\uDC70\uDCAC\uDCB0\uDCB5-\uDD00\uDD2E\uDD3E-\uDDFF\uDE04\uDE20\uDE23\uDE25\uDE26\uDE28\uDE33\uDE38\uDE3A\uDE3C-\uDE41\uDE43-\uDE46\uDE48\uDE4A\uDE4C\uDE50\uDE53\uDE55\uDE56\uDE58\uDE5A\uDE5C\uDE5E\uDE60\uDE63\uDE65\uDE66\uDE6B\uDE73\uDE78\uDE7D\uDE7F\uDE8A\uDE9C-\uDEA0\uDEA4\uDEAA\uDEBC-\uDFFF]|\uD83C[\uDC00-\uDCFF\uDD0D-\uDFFF]|\uD83E[\uDC00-\uDFEF\uDFFA-\uDFFF]|\uD869[\uDEE0-\uDEFF]|\uD86D[\uDF3A-\uDF3F]|\uD86E[\uDC1E\uDC1F]|\uD873[\uDEA2-\uDEAF]|\uD87A[\uDFE1-\uDFEF]|\uD87B[\uDE5E-\uDFFF]|\uD87E[\uDE1E-\uDFFF]|\uD884[\uDF4B-\uDF4F]|\uD888[\uDFB0-\uDFFF]|[\uD800-\uDBFF](?![\uDC00-\uDFFF])|(?:[^\uD800-\uDBFF]|^)[\uDC00-\uDFFF])/g, '');
  if (letters && window.input.titleAcronyms.indexOf(letters.toUpperCase()) >= 0) return word.toUpperCase();
  if (!shouting && /(?:[A-Z\xC0-\xD6\xD8-\xDE\u0100\u0102\u0104\u0106\u0108\u010A\u010C\u010E\u0110\u0112\u0114\u0116\u0118\u011A\u011C\u011E\u0120\u0122\u0124\u0126\u0128\u012A\u012C\u012E\u0130\u0132\u0134\u0136\u0139\u013B\u013D\u013F\u0141\u0143\u0145\u0147\u014A\u014C\u014E\u0150\u0152\u0154\u0156\u0158\u015A\u015C\u015E\u0160\u0162\u0164\u0166\u0168\u016A\u016C\u016E\u0170\u0172\u0174\u0176\u0178\u0179\u017B\u017D\u0181\u0182\u0184\u0186\u0187\u0189-\u018B\u018E-\u0191\u0193\u0194\u0196-\u0198\u019C\u019D\u019F\u01A0\u01A2\u01A4\u01A6\u01A7\u01A9\u01AC\u01AE\u01AF\u01B1-\u01B3\u01B5\u01B7\u01B8\u01BC\u01C4\u01C7\u01CA\u01CD\u01CF\u01D1\u01D3\u01D5\u01D7\u01D9\u01DB\u01DE\u01E0\u01E2\u01E4\u01E6\u01E8\u01EA\u01EC\u01EE\u01F1\u01F4\u01F6-\u01F8\u01FA\u01FC\u01FE\u0200\u0202\u0204\u0206\u0208\u020A\u020C\u020E\u0210\u0212\u0214\u0216\u0218\u021A\u021C\u021E\u0220\u0222\u0224\u0226\u0228\u022A\u022C\u022E\u0230\u0232\u023A\u023B\u023D\u023E\u0241\u0243-\u0246\u0248\u024A\u024C\u024E\u0370\u0372\u0376\u037F\u0386\u0388-\u038A\u038C\u038E\u038F\u0391-\u03A1\u03A3-\u03AB\u03CF\u03D2-\u03D4\u03D8\u03DA\u03DC\u03DE\u03E0\u03E2\u03E4\u03E6\u03E8\u03EA\u03EC\u03EE\u03F4\u03F7\u03F9\u03FA\u03FD-\u042F\u0460\u0462\u0464\u0466\u0468\u046A\u046C\u046E\u0470\u0472\u0474\u0476\u0478\u047A\u047C\u047E\u0480\u048A\u048C\u048E\u0490\u0492\u0494\u0496\u0498\u049A\u049C\u049E\u04A0\u04A2\u04A4\u04A6\u04A8\u04AA\u04AC\u04AE\u04B0\u04B2\u04B4\u04B6\u04B8\u04BA\u04BC\u04BE\u04C0\u04C1\u04C3\u04C5\u04C7\u04C9\u04CB\u04CD\u04D0\u04D2\u04D4\u04D6\u04D8\u04DA\u04DC\u04DE\u04E0\u04E2\u04E4\u04E6\u04E8\u04EA\u04EC\u04EE\u04F0\u04F2\u04F4\u04F6\u04F8\u04FA\u04FC\u04FE\u0500\u0502\u0504\u0506\u0508\u050A\u050C\u050E\u0510\u0512\u0514\u0516\u0518\u051A\u051C\u051E\u0520\u0522\u0524\u0526\u0528\u052A\u052C\u052E\u0531-\u0556\u10A0-\u10C5\u10C7\u10CD\u13A0-\u13F5\u1C89\u1C90-\u1CBA\u1CBD-\u1CBF\u1E00\u1E02\u1E04\u1E06\u1E08\u1E0A\u1E0C\u1E0E\u1E10\u1E12\u1E14\u1E16\u1E18\u1E1A\u1E1C\u1E1E\u1E20\u1E22\u1E24\u1E26\u1E28\u1E2A\u1E2C\u1E2E\u1E30\u1E32\u1E34\u1E36\u1E38\u1E3A\u1E3C\u1E3E\u1E40\u1E42\u1E44\u1E46\u1E48\u1E4A\u1E4C\u1E4E\u1E50\u1E52\u1E54\u1E56\u1E58\u1E5A\u1E5C\u1E5E\u1E60\u1E62\u1E64\u1E66\u1E68\u1E6A\u1E6C\u1E6E\u1E70\u1E72\u1E74\u1E76\u1E78\u1E7A\u1E7C\u1E7E\u1E80\u1E82\u1E84\u1E86\u1E88\u1E8A\u1E8C\u1E8E\u1E90\u1E92\u1E94\u1E9E\u1EA0\u1EA2\u1EA4\u1EA6\u1EA8\u1EAA\u1EAC\u1EAE\u1EB0\u1EB2\u1EB4\u1EB6\u1EB8\u1EBA\u1EBC\u1EBE\u1EC0\u1EC2\u1EC4\u1EC6\u1EC8\u1ECA\u1ECC\u1ECE\u1ED0\u1ED2\u1ED4\u1ED6\u1ED8\u1EDA\u1EDC\u1EDE\u1EE0\u1EE2\u1EE4\u1EE6\u1EE8\u1EEA\u1EEC\u1EEE\u1EF0\u1EF2\u1EF4\u1EF6\u1EF8\u1EFA\u1EFC\u1EFE\u1F08-\u1F0F\u1F18-\u1F1D\u1F28-\u1F2F\u1F38-\u1F3F\u1F48-\u1F4D\u1F59\u1F5B\u1F5D\u1F5F\u1F68-\u1F6F\u1FB8-\u1FBB\u1FC8-\u1FCB\u1FD8-\u1FDB\u1FE8-\u1FEC\u1FF8-\u1FFB\u2102\u2107\u210B-\u210D\u2110-\u2112\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u2130-\u2133\u213E\u213F\u2145\u2183\u2C00-\u2C2F\u2C60\u2C62-\u2C64\u2C67\u2C69\u2C6B\u2C6D-\u2C70\u2C72\u2C75\u2C7E-\u2C80\u2C82\u2C84\u2C86\u2C88\u2C8A\u2C8C\u2C8E\u2C90\u2C92\u2C94\u2C96\u2C98\u2C9A\u2C9C\u2C9E\u2CA0\u2CA2\u2CA4\u2CA6\u2CA8\u2CAA\u2CAC\u2CAE\u2CB0\u2CB2\u2CB4\u2CB6\u2CB8\u2CBA\u2CBC\u2CBE\u2CC0\u2CC2\u2CC4\u2CC6\u2CC8\u2CCA\u2CCC\u2CCE\u2CD0\u2CD2\u2CD4\u2CD6\u2CD8\u2CDA\u2CDC\u2CDE\u2CE0\u2CE2\u2CEB\u2CED\u2CF2\uA640\uA642\uA644\uA646\uA648\uA64A\uA64C\uA64E\uA650\uA652\uA654\uA656\uA658\uA65A\uA65C\uA65E\uA660\uA662\uA664\uA666\uA668\uA66A\uA66C\uA680\uA682\uA684\uA686\uA688\uA68A\uA68C\uA68E\uA690\uA692\uA694\uA696\uA698\uA69A\uA722\uA724\uA726\uA728\uA72A\uA72C\uA72E\uA732\uA734\uA736\uA738\uA73A\uA73C\uA73E\uA740\uA742\uA744\uA746\uA748\uA74A\uA74C\uA74E\uA750\uA752\uA754\uA756\uA758\uA75A\uA75C\uA75E\uA760\uA762\uA764\uA766\uA768\uA76A\uA76C\uA76E\uA779\uA77B\uA77D\uA77E\uA780\uA782\uA784\uA786\uA78B\uA78D\uA790\uA792\uA796\uA798\uA79A\uA79C\uA79E\uA7A0\uA7A2\uA7A4\uA7A6\uA7A8\uA7AA-\uA7AE\uA7B0-\uA7B4\uA7B6\uA7B8\uA7BA\uA7BC\uA7BE\uA7C0\uA7C2\uA7C4-\uA7C7\uA7C9\uA7CB\uA7CC\uA7D0\uA7D6\uA7D8\uA7DA\uA7DC\uA7F5\uFF21-\uFF3A]|\uD801[\uDC00-\uDC27\uDCB0-\uDCD3\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95]|\uD803[\uDC80-\uDCB2\uDD50-\uDD65]|\uD806[\uDCA0-\uDCBF]|\uD81B[\uDE40-\uDE5F]|\uD835[\uDC00-\uDC19\uDC34-\uDC4D\uDC68-\uDC81\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB5\uDCD0-\uDCE9\uDD04\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD38\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD6C-\uDD85\uDDA0-\uDDB9\uDDD4-\uDDED\uDE08-\uDE21\uDE3C-\uDE55\uDE70-\uDE89\uDEA8-\uDEC0\uDEE2-\uDEFA\uDF1C-\uDF34\uDF56-\uDF6E\uDF90-\uDFA8\uDFCA]|\uD83A[\uDD00-\uDD21])/.test(word)) return word;
  var lower = word.toLowerCase();
  if (!first && window.input.titleSmallWords.indexOf(lower) >= 0) return lower;
  if (word.indexOf('-') >= 0) return word.split('-').map(function (part) {
    return window.input.titleWord(part, true, shouting);
  }).join('-');
  if (word.indexOf("'") >= 0) return word.split("'").map(function (part, index) {
    return index === 0 || part.length > 1 ? window.input.titleWord(part, true, shouting) : part.toLowerCase();
  }).join("'");
  return lower.replace(/(?<!(?:[0-9A-Za-z\xAA\xB2\xB3\xB5\xB9\xBA\xBC-\xBE\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u0660-\u0669\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07C0-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0966-\u096F\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09E6-\u09F1\u09F4-\u09F9\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A66-\u0A6F\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AE6-\u0AEF\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B66-\u0B6F\u0B71-\u0B77\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0BE6-\u0BF2\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C66-\u0C6F\u0C78-\u0C7E\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CE6-\u0CEF\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D58-\u0D61\u0D66-\u0D78\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DE6-\u0DEF\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F20-\u0F33\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F-\u1049\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u1090-\u1099\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1369-\u137C\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u17E0-\u17E9\u17F0-\u17F9\u1810-\u1819\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19DA\u1A00-\u1A16\u1A20-\u1A54\u1A80-\u1A89\u1A90-\u1A99\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B50-\u1B59\u1B83-\u1BA0\u1BAE-\u1BE5\u1C00-\u1C23\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C8A\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2070\u2071\u2074-\u2079\u207F-\u2089\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2150-\u2189\u2460-\u249B\u24EA-\u24FF\u2776-\u2793\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2CFD\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u3192-\u3195\u31A0-\u31BF\u31F0-\u31FF\u3220-\u3229\u3248-\u324F\u3251-\u325F\u3280-\u3289\u32B1-\u32BF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CD\uA7D0\uA7D1\uA7D3\uA7D5-\uA7DC\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA830-\uA835\uA840-\uA873\uA882-\uA8B3\uA8D0-\uA8D9\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA900-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF-\uA9D9\uA9E0-\uA9E4\uA9E6-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA50-\uAA59\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD07-\uDD33\uDD40-\uDD78\uDD8A\uDD8B\uDE80-\uDE9C\uDEA0-\uDED0\uDEE1-\uDEFB\uDF00-\uDF23\uDF2D-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDDC0-\uDDF3\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC58-\uDC76\uDC79-\uDC9E\uDCA7-\uDCAF\uDCE0-\uDCF2\uDCF4\uDCF5\uDCFB-\uDD1B\uDD20-\uDD39\uDD80-\uDDB7\uDDBC-\uDDCF\uDDD2-\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE40-\uDE48\uDE60-\uDE7E\uDE80-\uDE9F\uDEC0-\uDEC7\uDEC9-\uDEE4\uDEEB-\uDEEF\uDF00-\uDF35\uDF40-\uDF55\uDF58-\uDF72\uDF78-\uDF91\uDFA9-\uDFAF]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDCFA-\uDD23\uDD30-\uDD39\uDD40-\uDD65\uDD6F-\uDD85\uDE60-\uDE7E\uDE80-\uDEA9\uDEB0\uDEB1\uDEC2-\uDEC4\uDF00-\uDF27\uDF30-\uDF45\uDF51-\uDF54\uDF70-\uDF81\uDFB0-\uDFCB\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC52-\uDC6F\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD03-\uDD26\uDD36-\uDD3F\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDD0-\uDDDA\uDDDC\uDDE1-\uDDF4\uDE00-\uDE11\uDE13-\uDE2B\uDE3F\uDE40\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDEF0-\uDEF9\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61\uDF80-\uDF89\uDF8B\uDF8E\uDF90-\uDFB5\uDFB7\uDFD1\uDFD3]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC50-\uDC59\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE50-\uDE59\uDE80-\uDEAA\uDEB8\uDEC0-\uDEC9\uDED0-\uDEE3\uDF00-\uDF1A\uDF30-\uDF3B\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCF2\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDD50-\uDD59\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8\uDFC0-\uDFE0\uDFF0-\uDFF9]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC50-\uDC6C\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD50-\uDD59\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDDA0-\uDDA9\uDEE0-\uDEF2\uDF02\uDF04-\uDF10\uDF12-\uDF33\uDF50-\uDF59\uDFB0\uDFC0-\uDFD4]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD80E\uD80F\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD887][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F\uDC41-\uDC46\uDC60-\uDFFF]|\uD810[\uDC00-\uDFFA]|\uD811[\uDC00-\uDE46]|\uD818[\uDD00-\uDD1D\uDD30-\uDD39]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDE70-\uDEBE\uDEC0-\uDEC9\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF50-\uDF59\uDF5B-\uDF61\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDD40-\uDD6C\uDD70-\uDD79\uDE40-\uDE96\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD32\uDD50-\uDD52\uDD55\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD833[\uDCF0-\uDCF9]|\uD834[\uDEC0-\uDED3\uDEE0-\uDEF3\uDF60-\uDF78]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]|\uD838[\uDC30-\uDC6D\uDD00-\uDD2C\uDD37-\uDD3D\uDD40-\uDD49\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB\uDEF0-\uDEF9]|\uD839[\uDCD0-\uDCEB\uDCF0-\uDCF9\uDDD0-\uDDED\uDDF0-\uDDFA\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDCC7-\uDCCF\uDD00-\uDD43\uDD4B\uDD50-\uDD59]|\uD83B[\uDC71-\uDCAB\uDCAD-\uDCAF\uDCB1-\uDCB4\uDD01-\uDD2D\uDD2F-\uDD3D\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD83C[\uDD00-\uDD0C]|\uD83E[\uDFF0-\uDFF9]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF39\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD888[\uDC00-\uDFAF]))(?:[A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088E\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C8A\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7CD\uA7D0\uA7D1\uA7D3\uA7D5-\uA7DC\uA7F2-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDDC0-\uDDF3\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDD4A-\uDD65\uDD6F-\uDD85\uDE80-\uDEA9\uDEB0\uDEB1\uDEC2-\uDEC4\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE3F\uDE40\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61\uDF80-\uDF89\uDF8B\uDF8E\uDF90-\uDFB5\uDFB7\uDFD1\uDFD3]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8\uDFC0-\uDFE0]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDEE0-\uDEF2\uDF02\uDF04-\uDF10\uDF12-\uDF33\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD80E\uD80F\uD81C-\uD820\uD822\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD887][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F\uDC41-\uDC46\uDC60-\uDFFF]|\uD810[\uDC00-\uDFFA]|\uD811[\uDC00-\uDE46]|\uD818[\uDD00-\uDD1D]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDD40-\uDD6C\uDE40-\uDE7F\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3]|\uD821[\uDC00-\uDFF7]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD08]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD32\uDD50-\uDD52\uDD55\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]|\uD838[\uDC30-\uDC6D\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDCD0-\uDCEB\uDDD0-\uDDED\uDDF0\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF39\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD888[\uDC00-\uDFAF])/g, function (start) {
    return start.toUpperCase();
  });
};
window.input.toTitleCase = function (value) {
  if (!value || !value.trim()) return '';
  var shouting = !/(?:[a-z\xB5\xDF-\xF6\xF8-\xFF\u0101\u0103\u0105\u0107\u0109\u010B\u010D\u010F\u0111\u0113\u0115\u0117\u0119\u011B\u011D\u011F\u0121\u0123\u0125\u0127\u0129\u012B\u012D\u012F\u0131\u0133\u0135\u0137\u0138\u013A\u013C\u013E\u0140\u0142\u0144\u0146\u0148\u0149\u014B\u014D\u014F\u0151\u0153\u0155\u0157\u0159\u015B\u015D\u015F\u0161\u0163\u0165\u0167\u0169\u016B\u016D\u016F\u0171\u0173\u0175\u0177\u017A\u017C\u017E-\u0180\u0183\u0185\u0188\u018C\u018D\u0192\u0195\u0199-\u019B\u019E\u01A1\u01A3\u01A5\u01A8\u01AA\u01AB\u01AD\u01B0\u01B4\u01B6\u01B9\u01BA\u01BD-\u01BF\u01C6\u01C9\u01CC\u01CE\u01D0\u01D2\u01D4\u01D6\u01D8\u01DA\u01DC\u01DD\u01DF\u01E1\u01E3\u01E5\u01E7\u01E9\u01EB\u01ED\u01EF\u01F0\u01F3\u01F5\u01F9\u01FB\u01FD\u01FF\u0201\u0203\u0205\u0207\u0209\u020B\u020D\u020F\u0211\u0213\u0215\u0217\u0219\u021B\u021D\u021F\u0221\u0223\u0225\u0227\u0229\u022B\u022D\u022F\u0231\u0233-\u0239\u023C\u023F\u0240\u0242\u0247\u0249\u024B\u024D\u024F-\u0293\u0295-\u02AF\u0371\u0373\u0377\u037B-\u037D\u0390\u03AC-\u03CE\u03D0\u03D1\u03D5-\u03D7\u03D9\u03DB\u03DD\u03DF\u03E1\u03E3\u03E5\u03E7\u03E9\u03EB\u03ED\u03EF-\u03F3\u03F5\u03F8\u03FB\u03FC\u0430-\u045F\u0461\u0463\u0465\u0467\u0469\u046B\u046D\u046F\u0471\u0473\u0475\u0477\u0479\u047B\u047D\u047F\u0481\u048B\u048D\u048F\u0491\u0493\u0495\u0497\u0499\u049B\u049D\u049F\u04A1\u04A3\u04A5\u04A7\u04A9\u04AB\u04AD\u04AF\u04B1\u04B3\u04B5\u04B7\u04B9\u04BB\u04BD\u04BF\u04C2\u04C4\u04C6\u04C8\u04CA\u04CC\u04CE\u04CF\u04D1\u04D3\u04D5\u04D7\u04D9\u04DB\u04DD\u04DF\u04E1\u04E3\u04E5\u04E7\u04E9\u04EB\u04ED\u04EF\u04F1\u04F3\u04F5\u04F7\u04F9\u04FB\u04FD\u04FF\u0501\u0503\u0505\u0507\u0509\u050B\u050D\u050F\u0511\u0513\u0515\u0517\u0519\u051B\u051D\u051F\u0521\u0523\u0525\u0527\u0529\u052B\u052D\u052F\u0560-\u0588\u10D0-\u10FA\u10FD-\u10FF\u13F8-\u13FD\u1C80-\u1C88\u1C8A\u1D00-\u1D2B\u1D6B-\u1D77\u1D79-\u1D9A\u1E01\u1E03\u1E05\u1E07\u1E09\u1E0B\u1E0D\u1E0F\u1E11\u1E13\u1E15\u1E17\u1E19\u1E1B\u1E1D\u1E1F\u1E21\u1E23\u1E25\u1E27\u1E29\u1E2B\u1E2D\u1E2F\u1E31\u1E33\u1E35\u1E37\u1E39\u1E3B\u1E3D\u1E3F\u1E41\u1E43\u1E45\u1E47\u1E49\u1E4B\u1E4D\u1E4F\u1E51\u1E53\u1E55\u1E57\u1E59\u1E5B\u1E5D\u1E5F\u1E61\u1E63\u1E65\u1E67\u1E69\u1E6B\u1E6D\u1E6F\u1E71\u1E73\u1E75\u1E77\u1E79\u1E7B\u1E7D\u1E7F\u1E81\u1E83\u1E85\u1E87\u1E89\u1E8B\u1E8D\u1E8F\u1E91\u1E93\u1E95-\u1E9D\u1E9F\u1EA1\u1EA3\u1EA5\u1EA7\u1EA9\u1EAB\u1EAD\u1EAF\u1EB1\u1EB3\u1EB5\u1EB7\u1EB9\u1EBB\u1EBD\u1EBF\u1EC1\u1EC3\u1EC5\u1EC7\u1EC9\u1ECB\u1ECD\u1ECF\u1ED1\u1ED3\u1ED5\u1ED7\u1ED9\u1EDB\u1EDD\u1EDF\u1EE1\u1EE3\u1EE5\u1EE7\u1EE9\u1EEB\u1EED\u1EEF\u1EF1\u1EF3\u1EF5\u1EF7\u1EF9\u1EFB\u1EFD\u1EFF-\u1F07\u1F10-\u1F15\u1F20-\u1F27\u1F30-\u1F37\u1F40-\u1F45\u1F50-\u1F57\u1F60-\u1F67\u1F70-\u1F7D\u1F80-\u1F87\u1F90-\u1F97\u1FA0-\u1FA7\u1FB0-\u1FB4\u1FB6\u1FB7\u1FBE\u1FC2-\u1FC4\u1FC6\u1FC7\u1FD0-\u1FD3\u1FD6\u1FD7\u1FE0-\u1FE7\u1FF2-\u1FF4\u1FF6\u1FF7\u210A\u210E\u210F\u2113\u212F\u2134\u2139\u213C\u213D\u2146-\u2149\u214E\u2184\u2C30-\u2C5F\u2C61\u2C65\u2C66\u2C68\u2C6A\u2C6C\u2C71\u2C73\u2C74\u2C76-\u2C7B\u2C81\u2C83\u2C85\u2C87\u2C89\u2C8B\u2C8D\u2C8F\u2C91\u2C93\u2C95\u2C97\u2C99\u2C9B\u2C9D\u2C9F\u2CA1\u2CA3\u2CA5\u2CA7\u2CA9\u2CAB\u2CAD\u2CAF\u2CB1\u2CB3\u2CB5\u2CB7\u2CB9\u2CBB\u2CBD\u2CBF\u2CC1\u2CC3\u2CC5\u2CC7\u2CC9\u2CCB\u2CCD\u2CCF\u2CD1\u2CD3\u2CD5\u2CD7\u2CD9\u2CDB\u2CDD\u2CDF\u2CE1\u2CE3\u2CE4\u2CEC\u2CEE\u2CF3\u2D00-\u2D25\u2D27\u2D2D\uA641\uA643\uA645\uA647\uA649\uA64B\uA64D\uA64F\uA651\uA653\uA655\uA657\uA659\uA65B\uA65D\uA65F\uA661\uA663\uA665\uA667\uA669\uA66B\uA66D\uA681\uA683\uA685\uA687\uA689\uA68B\uA68D\uA68F\uA691\uA693\uA695\uA697\uA699\uA69B\uA723\uA725\uA727\uA729\uA72B\uA72D\uA72F-\uA731\uA733\uA735\uA737\uA739\uA73B\uA73D\uA73F\uA741\uA743\uA745\uA747\uA749\uA74B\uA74D\uA74F\uA751\uA753\uA755\uA757\uA759\uA75B\uA75D\uA75F\uA761\uA763\uA765\uA767\uA769\uA76B\uA76D\uA76F\uA771-\uA778\uA77A\uA77C\uA77F\uA781\uA783\uA785\uA787\uA78C\uA78E\uA791\uA793-\uA795\uA797\uA799\uA79B\uA79D\uA79F\uA7A1\uA7A3\uA7A5\uA7A7\uA7A9\uA7AF\uA7B5\uA7B7\uA7B9\uA7BB\uA7BD\uA7BF\uA7C1\uA7C3\uA7C8\uA7CA\uA7CD\uA7D1\uA7D3\uA7D5\uA7D7\uA7D9\uA7DB\uA7F6\uA7FA\uAB30-\uAB5A\uAB60-\uAB68\uAB70-\uABBF\uFB00-\uFB06\uFB13-\uFB17\uFF41-\uFF5A]|\uD801[\uDC28-\uDC4F\uDCD8-\uDCFB\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC]|\uD803[\uDCC0-\uDCF2\uDD70-\uDD85]|\uD806[\uDCC0-\uDCDF]|\uD81B[\uDE60-\uDE7F]|\uD835[\uDC1A-\uDC33\uDC4E-\uDC54\uDC56-\uDC67\uDC82-\uDC9B\uDCB6-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDCCF\uDCEA-\uDD03\uDD1E-\uDD37\uDD52-\uDD6B\uDD86-\uDD9F\uDDBA-\uDDD3\uDDEE-\uDE07\uDE22-\uDE3B\uDE56-\uDE6F\uDE8A-\uDEA5\uDEC2-\uDEDA\uDEDC-\uDEE1\uDEFC-\uDF14\uDF16-\uDF1B\uDF36-\uDF4E\uDF50-\uDF55\uDF70-\uDF88\uDF8A-\uDF8F\uDFAA-\uDFC2\uDFC4-\uDFC9\uDFCB]|\uD837[\uDF00-\uDF09\uDF0B-\uDF1E\uDF25-\uDF2A]|\uD83A[\uDD22-\uDD43])/.test(value);
  return value.trim().split(' ').filter(Boolean).map(function (word, index) {
    return window.input.titleWord(word, index === 0, shouting);
  }).join(' ');
};
window.input.enforceInputRestrictions = function () {
  var inputs = document.querySelectorAll('input[data-case], input[data-allowed], input[data-decimal], input.mud-input-slot[maxlength="1"]:not([disabled]):not([type="hidden"])');
  inputs.forEach(function (input) {
    if (input.dataset.restrictionsAttached === 'true') return;
    input.dataset.restrictionsAttached = 'true';
    var casing = input.getAttribute('data-case');
    var allowed = input.getAttribute('data-allowed');
    var navKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];
    if (casing === 'upper' || casing === 'lower') {
      input.addEventListener('input', function () {
        window.input.recase(this, casing === 'upper' ? this.value.toUpperCase() : this.value.toLowerCase());
      });
    }
    if (casing === 'name' || casing === 'title') {
      input.addEventListener('blur', function () {
        var cased = casing === 'title' ? window.input.toTitleCase(this.value) : window.input.toNameCase(this.value);
        if (cased === this.value) return;
        this.value = cased;
        this.dispatchEvent(new Event('change', {
          bubbles: true
        }));
      });
    }
    var decimals = input.getAttribute('data-decimal');
    if (decimals !== null) {
      var limit = parseInt(decimals, 10) === 0 ? 0 : 1;
      input.addEventListener('input', function () {
        var before = this.value;
        var seen = 0;
        var cleaned = '';
        var _iterator = _createForOfIteratorHelper(before),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var character = _step.value;
            if (character !== '.') {
              cleaned += character;
              continue;
            }
            if (seen < limit) {
              cleaned += character;
              seen++;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        if (cleaned === before) return;
        var at = this.selectionStart - (before.length - cleaned.length);
        this.value = cleaned;
        this.setSelectionRange(at, at);
      });
    }
    if (allowed) {
      var allowedSet = new Set(allowed.toLowerCase().split(''));
      input.addEventListener('keydown', function (event) {
        var key = event.key.toLowerCase();
        if (!allowedSet.has(key) && !navKeys.includes(event.key)) {
          event.preventDefault();
        }
      });
    }
  });
};

/**
 * Observes the DOM for dynamically inserted input elements and reapplies
 * case and character restriction logic when they appear.
 *
 * This function sets up a `MutationObserver` that watches for changes to
 * the DOM subtree and automatically re-invokes `input.enforceInputRestrictions`
 * whenever new nodes are added. This is useful for Blazor apps where inputs
 * may be rendered conditionally or via delayed components (e.g., modals, toggles).
 *
 * @function observeInputs
 * @memberof window.input
 */
window.input.observeInputs = function () {
  var observer = new MutationObserver(function () {
    window.input.enforceInputRestrictions();
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  window.input.enforceInputRestrictions();
};

/**
 * Adds a border fade animation to the specified element.
 * This function triggers a CSS animation on the element's border by toggling a CSS class,
 * creating a visual effect that can be used to draw attention to the element.
 * 
 * @function border
 * @memberof window.input
 * @param {string} elementId - The ID of the element to apply the border animation to.
 */
window.input.border = function (elementId) {
  var element = document.getElementById(elementId);
  if (element) {
    /**
     * Handles the end of the border fade animation.
     * This function removes the animation class from the element and cleans up
     * the event listener to ensure the animation can be triggered again in the future.
     * 
     * @function handleAnimationEnd
     * @memberof window.input
     * @private
     */
    var _handleAnimationEnd = function handleAnimationEnd() {
      element.classList.remove('border-fade-animation');
      element.removeEventListener('animationend', _handleAnimationEnd);
    };

    // Reset the animation by removing and re-adding the class
    element.addEventListener('animationend', _handleAnimationEnd);
    element.classList.remove('border-fade-animation');
    void element.offsetWidth; // Trigger reflow to restart the animation
    element.classList.add('border-fade-animation');
  }
};

/**
 * Attaches a global ENTER key handler to all elements with `data-enter-handler`,
 * using the element's `id` and a single .NET reference passed from Blazor.
 * Prevents Shift+Enter from triggering the action (preserves newline).
 *
 * @param {DotNetObject} dotNetRef - The .NET object to invoke the method on.
 */
window.input.autoAttachEnterHandlers = function (dotNetRef) {
  var inputs = document.querySelectorAll('[data-enter-handler]');
  inputs.forEach(function (el) {
    var method = el.getAttribute('data-enter-handler');
    var id = el.id;
    if (!method || !id || el.dataset.enterHandlerAttached === 'true') return;
    el.dataset.enterHandlerAttached = 'true';
    el.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' && !e.shiftKey) {
        e.preventDefault();
        dotNetRef.invokeMethodAsync(method);
      }
    });
  });
};

/**
 * Attaches an Enter key handler to a single input element.
 * Used only when that input needs to invoke .NET from Blazor.
 *
 * @param {string} elementId - The ID of the input element.
 * @param {DotNetObject} dotNetRef - Reference to the Blazor component.
 * @param {string} methodName - The [JSInvokable] method to call.
 */
window.input.attachEnterHandler = function (elementId, dotNetRef, methodName) {
  var el = document.getElementById(elementId);
  if (!el || el.dataset.enterHandlerAttached === 'true') return;
  el.dataset.enterHandlerAttached = 'true';
  el.addEventListener('keydown', /*#__PURE__*/function () {
    var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(e) {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            if (!(e.key === 'Enter' && !e.shiftKey)) {
              _context.n = 1;
              break;
            }
            e.preventDefault();
            _context.n = 1;
            return dotNetRef.invokeMethodAsync(methodName);
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }());
};
"use strict";

// ***********************************************************************
// Assembly         : Veriteq.Partner.Web
// Author           : Mike Palmer
// Created          : 06-21-2024
//
// Last Modified By : Mike Palmer
// Last Modified On : 06-21-2024
// ***********************************************************************
// <copyright file="_listener.js" company="NSA Group Ltd">
//     Copyright (c) NSA Group Ltd. All rights reserved.
// </copyright>
// <summary>
//     JavaScript utilities for handling global keyboard event listeners,
//     allowing customizable key sequences and associated actions.
// </summary>
// ***********************************************************************

window.listener = window.listener || {};

/**
 * Adds a global keyboard event listener for a specified key sequence and triggers
 * a specified callback function when the sequence is detected.
 *
 * @function add
 * @memberof window.listener
 * @param {string} keySequence - The key sequence to listen for (e.g., 'ctrl+k').
 * @param {string} methodPath - The global method path to call when the key sequence is detected (e.g., 'window.dialog.showNavbarSearchModal').
 * @param {any} methodParam - The parameter to pass to the method when it is called.
 */
window.listener.add = function (keySequence, methodPath, methodParam) {
  var keys = keySequence.split('+');
  var ctrlRequired = keys.includes('ctrl');
  var altRequired = keys.includes('alt');
  var shiftRequired = keys.includes('shift');
  var keyRequired = keys.find(function (k) {
    return !['ctrl', 'alt', 'shift'].includes(k);
  });
  document.addEventListener('keydown', function (event) {
    var ctrlPressed = event.ctrlKey;
    var altPressed = event.altKey;
    var shiftPressed = event.shiftKey;
    var keyPressed = event.key.toLowerCase();
    if (ctrlRequired === ctrlPressed && altRequired === altPressed && shiftRequired === shiftPressed && keyRequired === keyPressed) {
      event.preventDefault();
      var method = new Function('return ' + methodPath)();
      if (typeof method === 'function') {
        method(methodParam);
      }
    }
  });
};

/**
 * Removes the global keyboard event listener for a specified key sequence.
 *
 * @function remove
 * @memberof window.listener
 * @param {string} keySequence - The key sequence to stop listening for (e.g., 'ctrl+k').
 */
window.listener.remove = function (keySequence) {
  var handler = window.listener.handlers[keySequence];
  if (handler) {
    document.removeEventListener('keydown', handler);
    delete window.listener.handlers[keySequence];
  }
};
"use strict";

window.mapUtils = window.mapUtils || {};
window.mapUtils.maps = {};

/**
 * Initializes a Leaflet map at the specified coordinates and zoom level.
 * This function only initializes the map and doesn't add any markers.
 * 
 * @function initializeLeafletMap
 * @memberof window.mapUtils
 * @param {string} mapId - The ID of the HTML element to attach the map to.
 * @param {number} latitude - The latitude for the map's center.
 * @param {number} longitude - The longitude for the map's center.
 * @param {number} zoom - The zoom level of the map.
 */
window.mapUtils.initializeLeafletMapWithPin = function (mapId, latitude, longitude, zoom, label) {
  var map = L.map(mapId, {
    center: [latitude, longitude],
    zoomControl: false,
    scrollWheelZoom: false,
    doubleClickZoom: false,
    dragging: false
  }).setView([latitude, longitude], zoom);
  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
  }).addTo(map);
  window.mapUtils.maps[mapId] = map;
  window.mapUtils.addPin(mapId, latitude, longitude, 'green', label);
};

/**
 * Initializes a Leaflet map at the specified coordinates and zoom level.
 * This function only initializes the map and doesn't add any markers.
 * 
 * @function initializeLeafletMap
 * @memberof window.mapUtils
 * @param {string} mapId - The ID of the HTML element to attach the map to.
 * @param {number} latitude - The latitude for the map's center.
 * @param {number} longitude - The longitude for the map's center.
 * @param {number} zoom - The zoom level of the map.
 */
window.mapUtils.initializeLeafletMap = function (mapId) {
  var map = L.map(mapId, {
    center: [54.5593, -2.5879],
    zoomControl: false,
    scrollWheelZoom: false,
    doubleClickZoom: false,
    dragging: false
  }).setView([54.5593, -2.5879], 5);
  L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
  }).addTo(map);
  window.mapUtils.maps[mapId] = map;
};

/**
 * Adds a pin to the map with a specified color and optional label.
 * 
 * @function addPin
 * @memberof window.mapUtils
 * @param {string} mapId - The ID of the map container element.
 * @param {number} latitude - The latitude for the marker location.
 * @param {number} longitude - The longitude for the marker location.
 * @param {string} color - The color of the marker icon (e.g., 'red', 'green', 'blue').
 * @param {string} [label] - (Optional) The label text to display when hovering over the marker.
 */
window.mapUtils.addPin = function (mapId, latitude, longitude, color, label) {
  var map = window.mapUtils.maps[mapId];
  if (!map) {
    console.error("Map with ID ".concat(mapId, " not found!"));
    return;
  }
  var customIcon = L.icon({
    iconUrl: "/images/maps/pin-".concat(color, ".png"),
    iconSize: [25, 41],
    // Size of the pin icon
    iconAnchor: [12, 41],
    // Anchor the bottom of the pin at the correct position
    popupAnchor: [0, -41] // Align the popup directly above the pin
  });
  var marker = L.marker([latitude, longitude], {
    icon: customIcon
  }).addTo(map);
  if (label) {
    marker.bindTooltip(label, {
      permanent: true,
      direction: 'top',
      // Tooltip will appear above the marker
      offset: [0, -45],
      // Adjust the offset to place the label properly above the marker
      className: 'leaflet-tooltip'
    }).openTooltip();
  }
  return marker;
};

/**
 * Removes a map pin from the map.
 * 
 * @function removePin
 * @memberof window.mapUtils
 * @param {string} mapId - The ID of the map container element.
 * @param {object} marker - The Leaflet marker object to remove.
 */
window.mapUtils.removePin = function (mapId, marker) {
  var map = window.mapUtils.maps[mapId];
  if (!map) {
    console.error("Map with ID ".concat(mapId, " not found!"));
    return;
  }
  map.removeLayer(marker);
};

/**
 * Zooms the map to a specified zoom level.
 * 
 * @function zoomMap
 * @memberof window.mapUtils
 * @param {string} mapId - The ID of the map container element.
 * @param {number} zoomLevel - The zoom level to set on the map.
 */
window.mapUtils.zoomMap = function (mapId, zoomLevel) {
  var map = window.mapUtils.maps[mapId]; // Retrieve the map object by mapId

  if (!map) {
    console.error("Map with ID ".concat(mapId, " not found!"));
    return;
  }
  map.setZoom(zoomLevel);
};

/**
 * Pans the map to a specified latitude and longitude.
 * 
 * @function goToLocation
 * @memberof window.mapUtils
 * @param {string} mapId - The ID of the map container element.
 * @param {number} latitude - The latitude to pan to.
 * @param {number} longitude - The longitude to pan to.
 */
window.mapUtils.goToLocation = function (mapId, latitude, longitude) {
  var map = window.mapUtils.maps[mapId]; // Retrieve the map object by mapId

  if (!map) {
    console.error("Map with ID ".concat(mapId, " not found!"));
    return;
  }
  map.setView([latitude, longitude], map.getZoom());
};

/**
 * Smoothly flies the map to a specified latitude and longitude.
 * 
 * @function flyToLocation
 * @memberof window.mapUtils
 * @param {string} mapId - The ID of the map container element.
 * @param {number} latitude - The latitude to fly to.
 * @param {number} longitude - The longitude to fly to.
 */
window.mapUtils.flyToLocation = function (mapId, latitude, longitude) {
  var map = window.mapUtils.maps[mapId];
  if (!map) {
    console.error("Map with ID ".concat(mapId, " not found!"));
    return;
  }
  map.flyTo([latitude, longitude], map.getZoom());
};
"use strict";

// ***********************************************************************
// Assembly         : Veriteq.Partner.Web
// Author           : Mike Palmer
// Created          : 06-21-2024
//
// Last Modified By : Mike Palmer
// Last Modified On : 06-21-2024
// ***********************************************************************
// <copyright file="_navigation.js" company="NSA Group Ltd">
//     Copyright (c) NSA Group Ltd. All rights reserved.
// </copyright>
// <summary>
//     JavaScript utilities for handling navigation between URLs.
// </summary>
// ***********************************************************************

window.navigation = window.navigation || {};

/**
 * Navigates to a specified URL, optionally opening it in a new window or tab.
 *
 * @function to
 * @memberof window.navigation
 * @param {string} url - The URL to navigate to.
 * @param {boolean} newWindow - If true, opens the URL in a new window or tab; otherwise, navigates in the current window.
 */
window.navigation.to = function (url, newWindow) {
  if (newWindow) {
    window.open(url, '_blank');
  } else {
    window.location.href = url;
  }
};
"use strict";

// ***********************************************************************
// Assembly         : Veriteq.Partner.Web
// Author           : Mike Palmer
// Created          : 06-21-2024
//
// Last Modified By : Mike Palmer
// Last Modified On : 06-22-2024
// ***********************************************************************
// <copyright file="_notificationInformation.js" company="NSA Group Ltd">
//     Copyright (c) NSA Group Ltd. All rights reserved.
// </copyright>
// <summary>
//     JavaScript utilities for initializing and managing notifications, including 
//     automatic fade-out and removal of notification elements in a Blazor application.
// </summary>
// ***********************************************************************

window.notifications = window.notifications || {};

/**
 * Sets up a notification to fade out and be removed after a specified duration.
 * This function observes the DOM for the presence of the specified element and,
 * once found, triggers a fade-out animation after 3 seconds. Upon completion of the
 * animation, the element is removed via a Blazor method call.
 * 
 * @function informationclose
 * @memberof window.notifications
 * @param {string} elementId - The ID of the notification element to fade out and remove.
 * @param {object} dotNetHelper - The .NET object reference used to invoke methods in Blazor.
 */
window.notifications.informationclose = function (elementId, dotNetHelper) {
  var observer = new MutationObserver(function (mutations, observerInstance) {
    var element = document.getElementById(elementId);
    if (element) {
      observerInstance.disconnect(); // Stop observing once the element is found

      setTimeout(function () {
        element.classList.add('fade-out');
        element.addEventListener('animationend', function () {
          dotNetHelper.invokeMethodAsync('RemoveMessage', elementId);
        });
      }, 3000); // Start fade out after 3 seconds
    }
  });
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // If the element is already present when this function is called
  var element = document.getElementById(elementId);
  if (element) {
    observer.disconnect();
    setTimeout(function () {
      element.classList.add('fade-out');
      element.addEventListener('animationend', function () {
        dotNetHelper.invokeMethodAsync('RemoveMessage', elementId);
      });
    }, 3000); // Start fade out after 3 seconds
  }
};
"use strict";

// ***********************************************************************
// Assembly         : Veriteq.Partner.Web
// Author           : Mike Palmer
// Created          : 06-21-2024
//
// Last Modified By : Mike Palmer
// Last Modified On : 06-21-2024
// ***********************************************************************
// <copyright file="_offcanvas.js" company="NSA Group Ltd">
//     Copyright (c) NSA Group Ltd. All rights reserved.
// </copyright>
// <summary>
//     JavaScript utilities for opening and closing Bootstrap offcanvas elements,
//     providing a simple API for toggling offcanvas components in a Blazor application.
// </summary>
// ***********************************************************************

window.offcanvas = window.offcanvas || {};

/**
 * Opens the Bootstrap offcanvas element with the specified ID.
 * This function retrieves or creates an offcanvas instance associated with the element
 * and triggers the display of the offcanvas panel.
 * 
 * @function open
 * @memberof window.offcanvas
 * @param {string} elementId - The ID of the offcanvas element to open.
 */
window.offcanvas.open = function (elementId) {
  var offcanvasElement = document.getElementById(elementId);
  if (offcanvasElement) {
    var offcanvas = window.bootstrap.Offcanvas.getOrCreateInstance(offcanvasElement);
    offcanvas.show();
  }
};

/**
 * Closes the Bootstrap offcanvas element with the specified ID.
 * This function retrieves or creates an offcanvas instance associated with the element
 * and triggers the hiding of the offcanvas panel.
 * 
 * @function close
 * @memberof window.offcanvas
 * @param {string} elementId - The ID of the offcanvas element to close.
 */
window.offcanvas.close = function (elementId) {
  var offcanvasElement = document.getElementById(elementId);
  if (offcanvasElement) {
    var offcanvas = window.bootstrap.Offcanvas.getOrCreateInstance(offcanvasElement);
    offcanvas.hide();
  }
};
"use strict";

// ***********************************************************************
// Assembly         : Veriteq.Partner.Web
// Author           : Mike Palmer
// Created          : 06-21-2024
//
// Last Modified By : Mike Palmer
// Last Modified On : 06-21-2024
// ***********************************************************************
// <copyright file="_pagination.js" company="NSA Group Ltd">
//     Copyright (c) NSA Group Ltd. All rights reserved.
// </copyright>
// <summary>
//     JavaScript utilities for handling dynamic pagination in Blazor applications.
// </summary>
// ***********************************************************************

window.blazor = window.blazor || {};

/**
 * Calculates the maximum number of items that can be displayed within a specified element
 * based on the element's height and the root font size, without causing overflow.
 * 
 * @function getItemsPerPage
 * @memberof window.blazor
 * @param {string} elementId - The ID of the container element that holds the list of items.
 * @returns {number} The maximum number of items that can be displayed within the container.
 */
window.blazor.getItemsPerPage = function (elementId) {
  var element = document.getElementById(elementId);
  if (element) {
    var rootFontSize = parseFloat(getComputedStyle(document.documentElement).fontSize);
    var itemsToDisplay = element.offsetHeight / (rootFontSize * 4);
    return Math.floor(itemsToDisplay);
  }
  return 0;
};

/**
 * Calculates the maximum number of items that can be displayed within a specified element
 * based on the element's height and the root font size, without causing overflow.
 * 
 * @function initializePagination
 * @memberof window.blazor
 * @param {object} dotNetHelper - The .NET object reference used to invoke methods in Blazor.
 * @param {string} elementId - The ID of the container element that holds the list of items.
 */
window.blazor.initializePagination = function (dotNetHelper, elementId) {
  var maxItems = window.blazor.getItemsPerPage(elementId);
  dotNetHelper.invokeMethodAsync('UpdateItemsPerPageAsync', maxItems);
};

/**
 * Sets up a resize event listener that recalculates the maximum number of items
 * that can be displayed within the specified element whenever the window is resized.
 * The updated item count is then passed to a Blazor component via .NET interop.
 * 
 * @function getUpdatedItemsPerPageOnResize
 * @memberof window.blazor
 * @param {object} dotNetHelper - The .NET object reference used to invoke methods in Blazor.
 * @param {string} elementId - The ID of the container element that holds the list of items.
 * @returns {function} A function that, when called, removes the resize event listener.
 */
window.blazor.getUpdatedItemsPerPageOnResize = function (dotNetHelper, elementId) {
  if (!dotNetHelper || !elementId) return;
  var resizeListener = function resizeListener() {
    var maxItems = window.blazor.getItemsPerPage(elementId);
    if (typeof maxItems !== 'undefined' && maxItems !== null) {
      dotNetHelper.invokeMethodAsync('UpdateItemsPerPageAsync', maxItems);
    }
  };
  window.addEventListener('resize', resizeListener);
  return function () {
    return window.removeEventListener('resize', resizeListener);
  };
};
"use strict";

// ***********************************************************************
// Assembly         : Veriteq.Partner.Web
// Author           : Mike Palmer
// Created          : 06-21-2024
//
// Last Modified By : Mike Palmer
// Last Modified On : 06-21-2024
// ***********************************************************************
// <copyright file="_popover.js" company="NSA Group Ltd">
//     Copyright (c) NSA Group Ltd. All rights reserved.
// </copyright>
// <summary>
//     JavaScript utility for initializing Bootstrap popovers on elements that have 
//     the `data-bs-toggle="popover"` attribute, enabling popover functionality in a Blazor application.
// </summary>
// ***********************************************************************

window.popover = window.popover || {};

/**
 * Initializes all elements with the attribute `data-bs-toggle="popover"` as Bootstrap popovers.
 * This function scans the DOM for elements with the `data-bs-toggle="popover"` attribute and
 * initializes a Bootstrap popover instance for each one, enabling popover functionality.
 *
 * @function initialize
 * @memberof window.popover
 */
window.popover.initialize = function () {
  var popoverTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="popover"]'));
  popoverTriggerList.map(function (popoverTriggerEl) {
    return new window.bootstrap.Popover(popoverTriggerEl);
  });
};
"use strict";

// ***********************************************************************
// Assembly         : Veriteq.Partner.Web
// Author           : Mike Palmer
// Created          : 06-21-2024
//
// Last Modified By : Mike Palmer
// Last Modified On : 06-21-2024
// ***********************************************************************
// <copyright file="_resizing.js" company="NSA Group Ltd">
//     Copyright (c) NSA Group Ltd. All rights reserved.
// </copyright>
// <summary>
//     JavaScript utility for managing resizing events and dynamically adjusting the 
//     visibility of Veriteq input group elements based on their container's width.
// </summary>
// ***********************************************************************

window.resizing = window.resizing || {};

/**
 * Initializes event listeners for window resizing and DOM content loading,
 * and triggers the resizing logic for Veriteq input groups.
 * This function ensures that the input groups are correctly adjusted upon page load
 * and whenever the window is resized.
 * 
 * @function initialize
 * @memberof window.resizing
 */
window.resizing.initialize = function () {
  window.addEventListener('resize', resizing.veriteq_input_group);
  document.addEventListener('DOMContentLoaded', resizing.veriteq_input_group);
  resizing.veriteq_input_group();
};

/**
 * Handles the resizing logic for Veriteq input groups.
 * This function checks the width of the parent element of each `.veriteq-input-state` element,
 * and adds or removes the `veriteq-input-state__hidden` class based on the parent's width.
 * If the parent element's width is less than 120 pixels, the input state element is hidden.
 * 
 * @function veriteq_input_group
 * @memberof window.resizing
 */
window.resizing.veriteq_input_group = function () {
  var elements = document.querySelectorAll('.veriteq-input-state');
  elements.forEach(function (child) {
    var parent = child.closest('.veriteq-input-group');
    if (parent && parent.offsetWidth < 120) {
      child.classList.add('veriteq-input-state__hidden');
    } else {
      child.classList.remove('veriteq-input-state__hidden');
    }
  });
};
"use strict";

// ***********************************************************************
// Assembly         : Veriteq.Partner.Web
// Author           : Mike Palmer
// Created          : 06-21-2024
//
// Last Modified By : Mike Palmer
// Last Modified On : 06-22-2024
// ***********************************************************************
// <copyright file="_tooltip.js" company="NSA Group Ltd">
//     Copyright (c) NSA Group Ltd. All rights reserved.
// </copyright>
// <summary>
//     JavaScript utility for initializing and managing Bootstrap tooltips 
//     in a Blazor application, enabling rich user interactions with tooltip components.
// </summary>
// ***********************************************************************

window.tooltip = window.tooltip || {};

/**
 * Initializes Bootstrap tooltips for all elements that have a `title` attribute.
 * This function scans the DOM for elements with a `title` attribute, automatically
 * setting up Bootstrap tooltips for these elements to enhance user interaction.
 * 
 * @function initialize
 * @memberof window.tooltip
 */
window.tooltip.initialize = function () {
  var elements = document.querySelectorAll('[title]');
  elements.forEach(function (element) {
    console.log(element);
    element.setAttribute('data-bs-toggle', 'tooltip');
  });
  var tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
  tooltipTriggerList.forEach(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl);
  });
};

/**
 * Hides all currently visible Bootstrap tooltips.
 * This function searches the DOM for visible tooltips and hides them,
 * ensuring that any active tooltips are properly dismissed.
 * 
 * @function hide
 * @memberof window.tooltip
 */
window.tooltip.hide = function () {
  var tooltips = document.querySelectorAll('.tooltip.bs-tooltip-auto.fade.show');
  tooltips.forEach(function (tooltipEl) {
    var tooltip = bootstrap.Tooltip.getInstance(tooltipEl);
    if (tooltip) {
      tooltip.hide();
    } else {
      tooltipEl.classList.remove('show');
    }
  });
};
"use strict";

// ***********************************************************************
// Assembly         : Veriteq.Partner.Web
// Author           : Mike Palmer
// Created          : 06-21-2024
//
// Last Modified By : Mike Palmer
// Last Modified On : 06-22-2024
// ***********************************************************************
// <copyright file="_tooltip.js" company="NSA Group Ltd">
//     Copyright (c) NSA Group Ltd. All rights reserved.
// </copyright>
// <summary>
//     JavaScript utility for initializing and managing Bootstrap tooltips 
//     in a Blazor application, enabling rich user interactions with tooltip components.
// </summary>
// ***********************************************************************

window.user_profile = window.user_profile || {};

/**
 * Applies the saved user font size on load.
 *
 * @function applySavedFontSize
 * @memberof window.actions
 */
window.user_profile.applySavedFontSize = function () {
  localStorage.removeItem('userFontScale');
  var zoom = localStorage.getItem('userFontZoom');
  if (zoom) {
    document.documentElement.style.setProperty('--user-font-zoom', zoom);
  }
};

/**
 * Scales the type relative to the theme's base size and remembers the factor.
 *
 * @function setUserFontZoom
 * @memberof window.user_profile
 * @param {string} factor - A multiplier such as '0.9', '1' or '1.3'.
 */
window.user_profile.setUserFontZoom = function (factor) {
  document.documentElement.style.setProperty('--user-font-zoom', factor);
  localStorage.setItem('userFontZoom', factor);
};

/**
 * Returns the saved zoom factor, or null when the default applies.
 *
 * @function getUserFontZoom
 * @memberof window.user_profile
 * @returns {string|null} The saved factor, such as '1.1'.
 */
window.user_profile.getUserFontZoom = function () {
  return localStorage.getItem('userFontZoom');
};
"use strict";

// ***********************************************************************
// Assembly         : Veriteq.Partner.Web
// Author           : Mike Palmer
// Created          : 06-21-2024
//
// Last Modified By : Mike Palmer
// Last Modified On : 06-21-2024
// ***********************************************************************
// <copyright file="_validation.js" company="NSA Group Ltd">
//     Copyright (c) NSA Group Ltd. All rights reserved.
// </copyright>
// <summary>
//     JavaScript utility for initializing and managing form validation using 
//     Bootstrap's validation classes, ensuring that form submissions are validated client-side.
// </summary>
// ***********************************************************************

window.validation = window.validation || {};

/**
 * Initializes client-side validation for all forms with the class `needs-validation`.
 * This function sets up an event listener for the `submit` event on each form,
 * preventing submission if the form is invalid and applying Bootstrap's validation styles.
 *
 * @function initialize
 * @memberof window.validation
 */
window.validation.initialize = function () {
  var forms = document.querySelectorAll('.needs-validation');
  Array.prototype.slice.call(forms).forEach(function (form) {
    form.addEventListener('submit', function (event) {
      if (!form.checkValidity()) {
        event.preventDefault();
        event.stopPropagation();
      }
      form.classList.add('was-validated');
    }, false);
  });
};